import { Data_getInstanceimjb3qpxitzh as Data_getInstance } from './adapter/SavePartyMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePartyMutationSelections_getInstance2vihkeb54q44a as SavePartyMutationSelections_getInstance } from './selections/SavePartyMutationSelections.mjs';
import { SavePartyMutation_VariablesAdapter_instance3vyx4zhot72ia as SavePartyMutation_VariablesAdapter_instance } from './adapter/SavePartyMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveParty) {
        this.r6g_1 = saveParty;
      }
      toString() {
        return 'Data(saveParty=' + this.r6g_1 + ')';
      }
      hashCode() {
        return this.r6g_1 == null ? 0 : getBooleanHashCode(this.r6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.r6g_1 == other.r6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.s6g_1 = obj(Data_getInstance());
        this.t6g_1 = (new (Builder())('data', Companion_getInstance().p6d_1)).s43(SavePartyMutationSelections_getInstance().w6g_1).i37();
        this.u6g_1 = '5b3ae51d8ade4a5c5d05a76c9456f084fb3e26e5c7a80059ecbaefaf290cfef0';
        this.v6g_1 = 'saveParty';
      }
      s6d() {
        return 'mutation saveParty($input: SavePartyInput!) { saveParty(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePartyMutationClass;
function SavePartyMutation() {
  if (SavePartyMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.x6g_1 = input;
      }
      u6d() {
        return '5b3ae51d8ade4a5c5d05a76c9456f084fb3e26e5c7a80059ecbaefaf290cfef0';
      }
      operationId() {
        return this.u6d();
      }
      l47() {
        return Companion_getInstance_0().s6d();
      }
      v6d() {
        return 'saveParty';
      }
      operationName() {
        return this.v6d();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        SavePartyMutation_VariablesAdapter_instance.y6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return Companion_getInstance_0().s6g_1;
      }
      toString() {
        return 'SavePartyMutation(input=' + this.x6g_1.toString() + ')';
      }
      hashCode() {
        return this.x6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyMutation()))
          return false;
        if (!this.x6g_1.equals(other.x6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyMutation', VOID, VOID, [Mutation()]);
    SavePartyMutationClass = $;
  }
  return SavePartyMutationClass;
}
//region block: exports
export {
  Data as Datajamxha8esaab,
  SavePartyMutation as SavePartyMutation37kzgcr2r74ko,
};
//endregion

//# sourceMappingURL=SavePartyMutation.mjs.map
